// extracted by mini-css-extract-plugin
module.exports = {"display":"navbar_display__4l_cG"};